import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import NewHere from "./pages/NewHere";
import Meetings from "./pages/Meetings";
import About from "./pages/About";
import Stories from "./pages/Stories";
import Resources from "./pages/Resources";
import RecoveryJourney from "./pages/RecoveryJourney";
import RecoveryJourneyStep from "./pages/RecoveryJourneyStep";
import Contact from "./pages/Contact";
import PrayerRequest from "./pages/PrayerRequest";
import Videos from "./pages/Videos";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/new-here" element={<NewHere />} />
        <Route path="/meetings" element={<Meetings />} />
        <Route path="/about" element={<About />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/recovery-journey" element={<RecoveryJourney />} />
        <Route path="/recovery-journey/:step" element={<RecoveryJourneyStep />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/prayer-request" element={<PrayerRequest />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}